import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { handleVerifyEmail } from "@fuse/utils/Firebase"

import { VERIFY } from "@fuse/pages/emailVerification/constant"

export const useVerify = () => {
  const [verificationStatus, setVerificationStatus] = useState(
    VERIFY.EMAIL.VERIFICATION_IN_PROGRESS,
  )
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (!searchParams) return

    onEmailVerify(searchParams)
  }, [searchParams])

  const onEmailVerify = async (params: URLSearchParams) => {
    try {
      const actionCode = params.get("oobCode")
      await handleVerifyEmail(actionCode)
      setVerificationStatus(VERIFY.EMAIL.VERIFICATION_SUCCESS)
    } catch (error) {
      setVerificationStatus(VERIFY.EMAIL.VERIFICATION_FAILED)
    }
  }

  return {
    verificationStatus,
  }
}
